// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5946) return "static/chunks/5946-3aeae241deef80e8.js";
	if (chunkId === 471) return "static/chunks/471-830ebfafc4f4c859.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3922":"4f2c60ebd3778c10","6112":"2cbcfef9522b83e8"}[chunkId] + ".js";
};